module.exports = __webpack_public_path__ + "static/media/ain_ghazal_text_02.c178cf8e.jpg";